__turbopack_context__.v({
  "arrow": "scroll-row-module-scss-module__JyZfDq__arrow",
  "controls": "scroll-row-module-scss-module__JyZfDq__controls",
  "head": "scroll-row-module-scss-module__JyZfDq__head",
  "heading": "scroll-row-module-scss-module__JyZfDq__heading",
  "item": "scroll-row-module-scss-module__JyZfDq__item",
  "root": "scroll-row-module-scss-module__JyZfDq__root",
  "track": "scroll-row-module-scss-module__JyZfDq__track",
});
